import produce from 'immer'
import { NlpModel, NlpModelId } from '@feedyou/schema'
import { __enforceTypescriptConstraint, isNotEmptyElement } from '@feedyou/utils'

import { Schema } from '../constants'

export const injectModelsToSchema = (
  schema: Schema,
  models: NlpModel[],
  preselectedModelId?: NlpModelId
): Schema => {
  return produce(schema, draft => {
    try {
      const propertiesForChooseOption = draft.properties.testAgainstModels.oneOf[2]?.properties
      __enforceTypescriptConstraint<{ mode: { const: 'CHOOSE' } }>(propertiesForChooseOption) // To make sure the property still exists where it should

      propertiesForChooseOption.chosenModels.items.anyOf = models.map(createAnyofOptionForModel)
      propertiesForChooseOption.chosenModels.default = [preselectedModelId].filter(
        isNotEmptyElement
      )
    } catch (e) {
      console.error('FAILED TO INJECT NLP MODELS TO FORM SCHEMA')
    }
  })
}

const createAnyofOptionForModel = (model: NlpModel) => ({
  const: model.id,
  title: model.name || model.id
})
